import {
    FETCH_TOP_STRENGTH_TOP_DEV_START,
    FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS,
    FETCH_TOP_STRENGTH_TOP_DEV_FAIL,

} from "../../../constants";
import {
    FETCH_TOP_STRENGTH_TOP_DEV_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getTopStrengthTopDev = createVisualizationFetchAction(FETCH_TOP_STRENGTH_TOP_DEV_URL, {
    START: FETCH_TOP_STRENGTH_TOP_DEV_START,
    SUCCESS: FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS,
    FAIL: FETCH_TOP_STRENGTH_TOP_DEV_FAIL,
});

